import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { sizes } from 'utils/detection';
import EmployeeModel from 'models/Employee';
import { ThemeContext } from 'utils/theme';

import Wrapper from './styled/Wrapper';
import ContentWrapper from './styled/ContentWrapper';
import ItemWrapper from './styled/ItemWrapper';
import Role from './styled/Role';
import Name from './styled/Name';
import ProfileImage from './styled/ProfileImage';
import WrapperRole from './styled/WrapperRole';

export default class TeamMembers extends PureComponent {


  static defaultProps = {};

  static contextType = ThemeContext;

  state = {
    isMedium: false,
    currentRole: '',
    imageURL: '',
  };

  componentDidMount() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.setState({ isMedium: window.innerWidth >= sizes.medium });
  };

  onMouseOverRole = role => e => {
    this.setState({ currentRole: role });
    // if(appState.analytics)appState.analytics._trackEvent('AboutPage', 'hover role', role);
  };

  onMouseOverName = (imageSrc, zIndex) => e => {
    e.target.style.zIndex = zIndex;
    this.setState({ imageURL: imageSrc });
    // if(appState.analytics)appState.analytics._trackEvent('AboutPage', 'hover name');
  };

  render() {
    const { className, employees } = this.props;
    const { isMedium, currentRole, imageURL } = this.state;

    let membersSorted = employees.concat([]);
    membersSorted.sort((a, b) => {
      if (a.jobtitle.title > b.jobtitle.title) {
        return 1;
      } else if (a.jobtitle.title < b.jobtitle.title) {
        return -1;
      }
      return 0;
    });
    const uniqueRoles = [...new Set(membersSorted.map(member => member.jobtitle.title))].sort();

    return (
      <Wrapper className={className}>
        {isMedium && (
          <WrapperRole>
            {uniqueRoles.map(uniqueRole => (
              <Role
                key={uniqueRole}
                onMouseOver={this.onMouseOverRole(uniqueRole)}
                isMouseOverRole={uniqueRole === currentRole}
                theme={this.context}
              >
                {uniqueRole}
              </Role>
            ))}
          </WrapperRole>
        )}
        <ContentWrapper>
          {membersSorted.map(({ firstName, jobtitle, image }) => (
            <ItemWrapper key={image.url}>
              {!isMedium && <Role theme={this.context}>{jobtitle.title}</Role>}
              <Name
                onMouseLeave={this.onMouseOverName('', 0)}
                onMouseEnter={this.onMouseOverName(image.url, 10)}
                isMouseOverRole={jobtitle.title === currentRole}
                theme={this.context}
              >
                {firstName}
              </Name>
              {imageURL === image.url ? <ProfileImage src={imageURL} /> : ''}
            </ItemWrapper>
          ))}
        </ContentWrapper>
      </Wrapper>
    );
  }
}
